import { cn } from "@/shared/utils/cn"

export interface SectionTitleProps {
  title: string
  subtitle?: string
  className?: string
  align?: "left" | "center"
}

/** 区块标题：用于分隔落地页各模块 */
export function SectionTitle({
  title,
  subtitle,
  className,
  align = "left",
}: SectionTitleProps) {
  return (
    <div
      className={cn(
        "px-4 pb-3 pt-5",
        align === "center" && "text-center",
        className,
      )}
    >
      <h2 className="text-lg font-bold text-ink">{title}</h2>
      {subtitle && <p className="mt-1 text-sm text-ink-tertiary">{subtitle}</p>}
    </div>
  )
}
